import { AuthGuard } from "../../auth/helpers";
import { MyTicketListComponent } from "./pages/my-ticket-list/my-ticket-list.component";
import { AllUsersTicketListComponent } from "./pages/all-users-ticket-list/all-users-ticket-list.component";
import { CategoriesTicketListComponent } from "./pages/categories-ticket-list/categories-ticket-list.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const ticketRoutes: IRoute[] = [
  // lista i miei ticket
  {
    path: "dashboard/ticket/my-list",
    component: MyTicketListComponent,
    canActivate: [AuthGuard],
  },
  // lista di tutti i ticket
  {
    path: "dashboard/ticket/all-ticket-list",
    component: AllUsersTicketListComponent,
    canActivate: [AuthGuard],
  },
  // categorie dei ticket
  {
    path: "dashboard/ticket/categories-list",
    component: CategoriesTicketListComponent,
    canActivate: [AuthGuard],
  },
];
export default ticketRoutes;
